import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/components/login.component';
import { NotificationService } from '@ntap/core';
import { catchError, EMPTY, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  return next(req).pipe(
    catchError((err) => {
      const authService = injector.get(AuthService);
      if (
        err.status === HttpStatusCode.Forbidden &&
        authService.hasSessionStorage()
      ) {
        authService.logoutSilently();

        injector
          .get(Router)
          .navigateByUrl('/login')
          .then(() => {
            injector
              .get(NotificationService)
              .error('Vaša sesija je istekla. Molimo Vas prijavite se ponovo.');
          });

        return EMPTY;
      } else if (authService.hasSessionStorage()) {
        return throwError(() => err);
      } else {
        return EMPTY;
      }
    })
  );
};
